const routes = [
  {
    path: "/",
    exact: true,
    component: "Home",
  },
  {
    path: "/home-page",
    redirect: "/"
  },
  {
    path: "/about",
    component: "About",
  },
  {
    path: "/services",
    component: "Services",
  },
  // {
  //   path: "/blog",
  //   component: "Blog",
  // },
  // {
  //   path: "/blog/blog-details",
  //   component: "BlogDetails",
  // },
  {
    path: "/contact",
    component: "Contact",
  },
  {
    path: "/privacy-policy",
    component: "PrivacyPolicy",
  },
  {
    path: "/terms-conditions",
    component: "TermsConditions",
  },
  {
    path: "*",
    component: "FourZeroFour",
  },
];

export default routes;
